/* eslint-disable import/no-cycle */
import React from 'react';
import Description from './JsDocDescription';
import ExamplesBlock from './JsDocExamples';
import Members from './JsDocMembers';
import ReturnBlock from './JsDocReturnBlock';

var JsDocBlock = function JsDocBlock(_ref) {
  var definition = _ref.definition,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 2 : _ref$depth,
      _ref$ignoreParams = _ref.ignoreParams,
      ignoreParams = _ref$ignoreParams === void 0 ? [] : _ref$ignoreParams;
  if (!definition) return null;
  var nextLevel = depth + 1;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Description, {
    definition: definition
  }), /*#__PURE__*/React.createElement(Members, {
    definition: definition,
    level: nextLevel,
    ignoreParams: ignoreParams
  }), /*#__PURE__*/React.createElement(ReturnBlock, {
    definition: definition,
    level: nextLevel
  }), /*#__PURE__*/React.createElement(ExamplesBlock, {
    definition: definition,
    level: nextLevel
  }));
};

export default JsDocBlock;
export var fragment = "3012438255";